import React from 'react';
const FinalCTA = () => {
  return <section className="py-20 px-6 md:px-12 bg-gradient-to-b from-teal-50 to-white" data-id="element-68">
      <div className="max-w-4xl mx-auto text-center" data-id="element-69">
        <h2 className="text-3xl md:text-4xl font-bold text-teal-900 mb-6" data-id="element-70">
          Be one of the first 10.
        </h2>
        <p className="text-xl text-gray-700 mb-10" data-id="element-71">
          Give your clients what they truly need. And give yourself the tools to
          do less—while delivering more.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-72">
          <a href="https://www.neurotoned.com/offers/7S2eZfYL?coupon_code=PROFESSIONALACCESSPASS" className="bg-teal-700 hover:bg-teal-800 text-white py-3 px-8 rounded-md font-medium text-lg transition duration-300 text-center" data-id="element-73">
            Join Now for $499/year
          </a>
          <a href="https://calendly.com/madisonstarr/30min" className="border-2 border-teal-700 text-teal-700 hover:bg-teal-50 py-3 px-8 rounded-md font-medium text-lg transition duration-300 text-center" data-id="element-74">
            Book a Call
          </a>
        </div>
      </div>
    </section>;
};
export default FinalCTA;